import { render } from "./Edit.vue?vue&type=template&id=0e97e9fb&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=0e97e9fb&lang=scss"
import "./Edit.vue?vue&type=style&index=1&id=0e97e9fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e97e9fb"],['__file',"src/views/ShippingCodes/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e97e9fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e97e9fb', __exports__)) {
    api.reload('0e97e9fb', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=0e97e9fb&scoped=true", () => {
    api.rerender('0e97e9fb', render)
  })

}


export default __exports__